import React, { useState, useEffect } from "react";
import {
  Typography,
  Modal,
  Box,
  TextField,
  MenuItem,
  Button,
} from "@mui/material";
import ChatIcon from "@mui/icons-material/Chat";
import EmailIcon from "@mui/icons-material/Email";
import PhoneIcon from "@mui/icons-material/Phone";
import LanguageIcon from "@mui/icons-material/Language";
import { useNavigate } from "react-router-dom";
import { useLoading } from "../../../context/LoadingContext";
import { Auth } from "aws-amplify";
import { jwtDecode } from "jwt-decode";
import { postQuery } from "../../Requirement/services/RequirementServices";
import AlertModal from "../../Requirement/components/common/AlerModel";

const BuyerContactSupport = () => {
  const { setLoading } = useLoading();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [queryType, setQueryType] = useState(" ");
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");
  const [activeUser, setActiveUser] = useState("");
  const [modal, setModal] = useState({
    show: false,
    type: "info",
    title: "",
    message: "",
    nextAction: null,
  });

  const handleModalClose = () => {
    const action = modal.nextAction;
    setModal((prev) => ({ ...prev, show: false, nextAction: null }));
    if (action) action();
  };

  const redirectToMessage = () => {
    navigate("/buyer/messaging");
  };

  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setOpen(false);
    setQueryType("general");
    setMessage("");
  };

  useEffect(() => {
    const checkUser = async () => {
      try {
        const user = await Auth.currentAuthenticatedUser();
        const token = user.signInUserSession.idToken.jwtToken;
        const decodedToken = jwtDecode(token);
        const groups = decodedToken["cognito:groups"] || [];
        if (!groups.includes("AMTPL_BUYERS")) {
          await Auth.signOut();
          navigate("/login/buyer");
        } else {
          setActiveUser(user.attributes.email);
          //getBuyerInfo(user.attributes.email);
        }
      } catch (error) {
        console.error("Error checking user:", error);
        await Auth.signOut();
        navigate("/login/buyer");
      }
    };
    checkUser();
  }, [navigate]);
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      // Handle form submission (e.g., send email or API call)
      console.log("Query Type:", queryType);
      console.log("Message:", message);
      console.log("Message:", subject);
      const mailMessage = `<p><b>Subject:</b> ${subject}</p><p><b>Query Type:</b> ${queryType}</p><p><b>Message:</b> ${message}</p>`;

      const bodyMail = {
        target: "financerfqmail",
        MailInput: {
          toAddresses: ["support@grains.global"],
          subject: `AMTPL Admin: ${subject}`,
          msg: mailMessage,
        },
      };

      const result = await postQuery(bodyMail, "backendops");
      console.log(result.toAddresses.length);
      const email = "";
      if (result.toAddresses.length > 0) {
        setModal({
          show: true,
          type: "success",
          title: "Mail Sent!",
          message: `Email sent to tirtha.roy@agropreneurs.in.`,
          autoClose: false,
        });
      }
    } catch (error) {
      console.error("Error sending message:", error);
    } finally {
      setLoading(false);
      handleClose(); // Close modal after submission
    }
  };

  return (
    <div className="container">
      <AlertModal
        type={modal.type}
        title={modal.title}
        message={modal.message}
        showModal={modal.show}
        onClose={handleModalClose}
        onCancel={modal.onCancel}
        isConfirm={modal.isConfirm}
        buttonText="OK"
        autoClose={modal.autoClose}
      />
      <style>
        {`
          .support-card {
            background-color: #f5f5f5;
            border-radius: 8px;
            padding: 16px 25px;
            display: flex;
            flex-direction: column;
            gap: 8px;
            height: 100%;
            justify-content: center;
            text-align: left;
          }
          .header-text {
            margin-bottom: 20px;
          }
          .equal-height-row {
            display: flex;
            flex-wrap: wrap;
            align-items: stretch;
          }
          .font-style {
            font-size: 20px !important;
            display: flex;
            align-items: center;
            justify-content: flex-start;
            gap: 8px;
            color: #0d0dc1;
            font-weight: 600;
            p {
                color: #3c79b7;
            }
          }
          .font-style2 {
            font-size: 20px !important;
            display: flex;
            align-items: center;
            justify-content: flex-start;
            gap: 8px;
            color: #086308;
            font-weight: 600;
          }
          .font-style3 {
            font-size: 20px !important;
            display: flex;
            align-items: center;
            justify-content: flex-start;
            gap: 8px;
            color: #874a07;
            font-weight: 600;
          }
          .modal-content {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            width: 900px;
            background-color: #fff;
            border-radius: 12px;
            padding: 20px;
            box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
            text-align: center;
            font-family: Arial, sans-serif;
          }
          .modal-title {
            color: #1a0dab;
            font-size: 24px;
            font-weight: bold;
            margin-bottom: 20px;
          }
          .modal-form label {
            display: block;
            text-align: left;
            color: #5f6368;
            font-size: 14px;
            margin-bottom: 4px;
          }
          .modal-form .MuiTextField-root {
            width: 100%;
            margin-bottom: 16px;
          }
          .modal-form .MuiSelect-select {
            padding: 10px;
            border-radius: 4px;
            border: 1px solid #dadce0;
            background-color: #fff;
          }
          .modal-form .MuiInputBase-root {
            border-radius: 4px;
            border: 1px solid #dadce0;
          }
          .modal-form .MuiInputBase-input {
            padding: 10px;
          }
          .modal-form .MuiInputBase-multiline {
            padding: 10px;
            min-height: 100px;
          }
          .modal-buttons {
            display: flex;
            justify-content: flex-end;
            gap: 10px;
            margin-top: 20px;
          }
          .modal-buttons .MuiButton-root {
            padding: 8px 16px;
            border-radius: 4px;
            text-transform: none;
          }
          .modal-buttons .cancel {
            background-color: #e0e0e0;
            color: #202124;
          }
          .modal-buttons .send {
            background-color: #1a73e8;
            color: #fff;
          }
        `}
      </style>
      <div className="card p-4">
        <div
          className="table-header"
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginBottom: 5,
          }}
        >
          <div className="header-text">
            <div
              className="head-text"
              style={{ fontSize: "24px", fontWeight: "bold" }}
            >
              Contact Support
            </div>
            <div
              className="head-subtext"
              style={{ color: "#666", fontSize: "14px" }}
            >
              Choose how you'd like to reach out to our support team.
            </div>
          </div>
        </div>

        <div className="row g-4 equal-height-row">
          <div className="col-md-4 p-3">
            <div
              className="support-card"
              style={{ backgroundColor: "#E6F0FA" }}
            >
              <Typography variant="h6" className="font-style">
                <ChatIcon /> Chat with Us
              </Typography>
              <Typography
                variant="body2"
                color="textSecondary"
                style={{ fontSize: "14px" }}
              >
                Need quick help? Start a live chat with
                <br /> our support team.
              </Typography>
              <Typography
                variant="body2"
                color="primary"
                style={{ fontSize: "16px" }}
              >
                <div
                  onClick={redirectToMessage}
                  style={{
                    textDecoration: "none",
                    color: "#de6b14",
                    cursor: "pointer",
                  }}
                >
                  → Start Chat
                </div>
              </Typography>
            </div>
          </div>
          <div className="col-md-4 p-3">
            <div
              className="support-card"
              style={{ backgroundColor: "#E6F3E6" }}
            >
              <Typography variant="h6" className="font-style2">
                <EmailIcon /> Email Us
              </Typography>
              <Typography
                variant="body2"
                color="textSecondary"
                style={{ fontSize: "14px" }}
              >
                Prefer email? Write to us at <br />
                <a
                  href="#"
                  style={{ textDecoration: "none", color: "#1976d2" }}
                >
                  support@grains.global
                </a>
              </Typography>
              <Typography
                variant="body2"
                color="primary"
                style={{ fontSize: "16px" }}
              >
                <div
                  onClick={handleOpen}
                  style={{
                    textDecoration: "none",
                    color: "#de6b14",
                    cursor: "pointer",
                  }}
                >
                  → Send Email
                </div>
              </Typography>
            </div>
          </div>
          <div className="col-md-4 p-3">
            <div
              className="support-card"
              style={{ backgroundColor: "#FFF3E6" }}
            >
              <Typography variant="h6" className="font-style3">
                <PhoneIcon /> Call Support
              </Typography>
              <Typography
                variant="body2"
                color="textSecondary"
                style={{ fontSize: "14px" }}
              >
                Available: Monday to Friday, <br />
                9:00 AM - 6:00 PM (Indian Standard Time)
              </Typography>
              <Typography
                variant="body2"
                color="textSecondary"
                style={{
                  fontSize: "14px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "flex-start",
                  gap: "8px",
                }}
              >
                <PhoneIcon style={{ width: "15px" }} /> India:{" "}
                <a
                  href="tel:+919836236245"
                  style={{ textDecoration: "none", color: "#de6b14" }}
                >
                  +91 9836236245
                </a>
              </Typography>
            </div>
          </div>
        </div>
      </div>

      <Modal open={open} onClose={handleClose}>
        <Box className="modal-content">
          <div
            className="modal-title"
            style={{ fontSize: "18px !important", color: "#665d5d !important" }}
          >
            Contact Us
          </div>
          <form onSubmit={handleSubmit} className="modal-form">
            <label>Type of Query</label>
            <TextField
              select
              value={queryType}
              onChange={(e) => setQueryType(e.target.value)}
              variant="outlined"
              fullWidth
              required
            >
              <MenuItem value=" ">Select Query</MenuItem>
              <MenuItem value="technical">Technical Support</MenuItem>
              <MenuItem value="billing">Billing Issue</MenuItem>
              <MenuItem value="feedback">Product Feedback</MenuItem>
            </TextField>
            <label>Subject</label>
            <TextField
              text
              value={subject}
              onChange={(e) => setSubject(e.target.value)}
              variant="outlined"
              fullWidth
              required
              placeholder="Please type subject here..."
            ></TextField>
            <label>Message</label>
            <textarea
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              style={{ width: "100%" }}
              placeholder="Write a message..."
              rows="8"
              className="flex-1 p-2 border rounded-lg resize-none focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
            {/* <TextField
                                                multiline
                                                rows={4}
                                                value={message}
                                                onChange={(e) => setMessage(e.target.value)}
                                                variant="outlined"
                                                fullWidth
                                                placeholder="Please describe your query here..."
                                                required
                                            
                                            /> */}
            <div className="modal-buttons">
              <Button
                className="cancel"
                onClick={handleClose}
                style={{
                  backgroundColor: "#ccc",
                  color: "#fff",
                  width: "70px",
                }}
              >
                Cancel
              </Button>
              <Button
                type="submit"
                className="submit-btn-more"
                style={{
                  backgroundColor: "#de6b14",
                  color: "#fff",
                  width: "70px",
                }}
              >
                Send
              </Button>
            </div>
          </form>
        </Box>
      </Modal>
    </div>
  );
};

export default BuyerContactSupport;
